module.exports = __webpack_public_path__ + "static/media/que-hacer-en-tigre.2dee7ecf.md";